import { render, staticRenderFns } from "./SidebarZones.vue?vue&type=template&id=48eec7f9&scoped=true&"
import script from "./SidebarZones.vue?vue&type=script&lang=ts&"
export * from "./SidebarZones.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarZones.vue?vue&type=style&index=0&id=48eec7f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48eec7f9",
  null
  
)

export default component.exports